import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  CompositeReportDefinitionSummary,
  ModelUtils,
} from '../../../../AITemplates/models';
import { ExecutiveSummaryData } from '../executive-summary';

const messages = defineMessages({
  label: {
    id: 'CRDSelect.label',
    defaultMessage: 'Select a Composite Report Template',
  },
  default: {
    id: 'CRDSelect.default',
    defaultMessage: 'Default Annual Report',
  },
});

type CRDSelectProps = {
  crdDurableId?: string;
  setCrdDurableId: (crdDurableId?: string) => void;
  executiveSummary?: ExecutiveSummaryData;
  compositeReportDefinitions: CompositeReportDefinitionSummary[];
};

export const CRDSelect: React.FC<CRDSelectProps> = ({
  crdDurableId,
  setCrdDurableId,
  compositeReportDefinitions,
}) => {
  const { formatMessage } = useIntl();

  const setCrdFromDurableId = (durableId?: string) => {
    if (durableId) {
      const crd = compositeReportDefinitions.find(
        crd => crd.durableId === durableId,
      );
      setCrdDurableId(crd?.durableId);
    } else {
      setCrdDurableId(undefined);
    }
  };

  return (
    <Select
      label={formatMessage(messages.label)}
      value={crdDurableId ?? ''}
      onChange={value => setCrdFromDurableId(value)}
      fullWidth
    >
      <SelectOption
        key="no-selection"
        value=""
        title={formatMessage(messages.default)}
        subtitle=""
      />
      {compositeReportDefinitions.map(crd => (
        <SelectOption
          key={crd.durableId}
          value={crd.durableId}
          title={ModelUtils.getName(crd)} // Display name from path
          subtitle={crd.description} // Optional description
        />
      ))}
    </Select>
  );
};
